import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import "../App.css"; // Assuming a shared CSS file for consistent styling

const BillingPage = () => {
    const [plan, setPlan] = useState('');
    const [price, setPrice] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const selectedPlan = localStorage.getItem('selectedPlan');
        const selectedCountry = localStorage.getItem('selectedCountry');

        if (!selectedPlan || !selectedCountry) {
            navigate('/subscriptions'); // Redirect back if details are missing
        }

        setPlan(selectedPlan);
        // Set price based on plan and country (example logic)
        if (selectedPlan === 'Free Plan') setPrice('£0');
        else if (selectedPlan === 'Personal Plan') setPrice(selectedCountry === 'UK' ? '£10' : '$12');
        else if (selectedPlan === 'Family Plan') setPrice(selectedCountry === 'UK' ? '£15' : '$18');
        else if (selectedPlan === 'School/Educational Plan') setPrice('Custom Pricing'); // Example for schools
    }, [navigate]);

    const handleConfirm = () => {
        alert('Proceeding to payment...');
        navigate('/login'); // Redirect to login after payment
    };

    return (
        <div
            className="page-container"
            style={{
                backgroundImage: `url(${require('../assets/images/landing_background.jpg')})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                minHeight: '100vh',
            }}
        >
            <header className="page-header">
                <div className="logo">
                    <img
                        src={require('../assets/images/logo_name.PNG')}
                        alt="YourStoryWorld Logo"
                        style={{ height: '50px', cursor: 'pointer' }}
                        onClick={() => navigate('/')}
                    />
                </div>
                <nav style={{ display: 'flex', gap: '15px', justifyContent: 'flex-end' }}>
                    <button
                        onClick={() => navigate('/signin')}
                        className="header-button"
                    >
                        Sign In
                    </button>
                    <button
                        onClick={() => navigate('/help')}
                        className="header-button"
                    >
                        Help
                    </button>
                </nav>
            </header>

            <main className="page-content" style={{ textAlign: 'center', padding: '20px' }}>
                <h1>Billing Confirmation</h1>
                <p>You have selected: <strong>{plan}</strong></p>
                <p>Price: <strong>{price}</strong></p>
                <button
                    onClick={handleConfirm}
                    className="confirm-button"
                >
                    Proceed to Payment
                </button>
            </main>

            <footer className="page-footer">
                <p>&copy; {new Date().getFullYear()} YourStoryWorld. All rights reserved.</p>
                <nav style={{ marginTop: '10px' }}>
                    <a href="/about" className="footer-link">About Us</a>
                    <a href="/contact" className="footer-link">Contact</a>
                </nav>
            </footer>
        </div>
    );
};

export default BillingPage;
